import React from "react";
import { Button, Typography, Space, Row, Col } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const ComingSoon = () => {
    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            <Row justify="center" align="middle" style={{ height: "100vh" }}>
                <Col xs={22} sm={18} md={14} lg={10} xl={8}>
                    <div style={styles.content}>
                        <ClockCircleOutlined style={styles.icon} />
                        <Title level={2} style={styles.title}>
                            Coming Soon!
                        </Title>
                        <Text style={styles.text}>
                            We're working hard to bring you this feature. Stay tuned for
                            updates!
                        </Text>
                        <br />
                        <Space style={styles.buttonGroup}>
                            <Button type="primary" size="large" style={styles.button} onClick={() => navigate("/user/home")}>
                                Go Back
                            </Button>
                        </Space>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: "#f0f2f5",
        textAlign: "center",
    },
    content: {
        backgroundColor: "#ffffff",
        padding: "40px 20px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    },
    icon: {
        fontSize: "48px",
        color: "#a6cc43",
        marginBottom: "20px",
    },
    title: {
        marginBottom: "16px",
        color: "#333",
    },
    text: {
        fontSize: "16px",
        color: "#666",
        marginBottom: "24px",
    },
    buttonGroup: {
        marginTop: "16px",
    },
    button: {
        width: "150px",
        backgroundColor: '#a6cc43',
        borderColor: '#a6cc43'
    },
};

export default ComingSoon;
